import React from 'react';
import { PatientGender } from '../pacients';

const GENDER_OPTIONS: PatientGender[] = ['MASCULINO', 'FEMENINO', 'OTRO', 'NO_ESPECIFICADO'];

const PatientFormModal = ({
  isDialogOpen,
  editingPatient,
  formData,
  setFormData,
  handleSubmit,
  resetForm,
}) => {
  if (!isDialogOpen) {
    return null;
  }

  const title = editingPatient ? 'Editar Paciente' : 'Crear Nuevo Paciente';

  const handleContactChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      emergencyContact: {
        ...prev.emergencyContact,
        [name]: value,
      },
    }));
  };

  const handleFieldChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const inputClass =
    'focus:ring-primary-main w-full rounded border bg-black px-3 py-2 focus:outline-none focus:ring';
  const selectClass =
    'focus:ring-primary-main bg-primary-main w-full rounded border px-3 py-2 focus:ring';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 text-white">
      <div className="bg-primary-dark max-h-[90vh] max-w-xl overflow-y-auto rounded p-6 shadow-lg sm:w-full">
        <h3 className="mb-4 text-xl font-semibold">{title}</h3>
        <form
          onSubmit={handleSubmit}
          className="space-y-4"
        >
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">

            {/* Primer Nombre */}
            <div>
              <label className="block text-sm font-medium">Nombre</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* Apellido */}
            <div>
              <label className="block text-sm font-medium">Apellido</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* ID de Paciente (Solo en modo creación o no editable) */}
            <div>
              <label className="block text-sm font-medium">ID de Paciente (Código)</label>
              <input
                type="text"
                name="patientId"
                value={formData.patientId}
                onChange={handleFieldChange}
                className={inputClass}
                required
                disabled={!!editingPatient} // No permitir editar el ID
              />
            </div>
            {/* Género */}
            <div>
              <label className="block text-sm font-medium">Género</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleFieldChange}
                className={selectClass}
                required
              >
                {GENDER_OPTIONS.map(gender => (
                  <option
                    key={gender}
                    value={gender}
                  >
                    {gender.charAt(0).toUpperCase() +
                      gender.slice(1).toLowerCase().replace('_', ' ')}
                  </option>
                ))}
              </select>
            </div>
            {/* Cumpleaños */}
            <div>
              <label className="block text-sm font-medium">Cumpleaños</label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* Teléfono */}
            <div>
              <label className="block text-sm font-medium">Teléfono</label>
              <input
                type="text"
                name="phoneNumber"
                value={formData.phoneNumber || ''}
                onChange={handleFieldChange}
                className={inputClass}
              />
            </div>
          </div>
          {/* Dirección (Full Width) */}
          <div className="col-span-2">
            <label className="block text-sm font-medium">Dirección</label>
            <input
              type="text"
              name="address"
              value={formData.address || ''}
              onChange={handleFieldChange}
              className={inputClass}
            />
          </div>

          {/* Contacto de Emergencia */}
          <fieldset className="space-y-3 rounded border border-gray-600 p-3">
            <legend className="px-1 text-sm font-semibold">Contacto de Emergencia</legend>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label className="block text-sm font-medium">Nombre de Contacto</label>
                <input
                  type="text"
                  name="name"
                  value={formData.emergencyContact?.name || ''}
                  onChange={handleContactChange}
                  className={inputClass}
                />
              </div>
              <div>
                <label className="block text-sm font-medium">Teléfono de Contacto</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.emergencyContact?.phone || ''}
                  onChange={handleContactChange}
                  className={inputClass}
                />
              </div>
            </div>
          </fieldset>

          {/* Notas */}
          <div>
            <label className="block text-sm font-medium">Notas Adicionales</label>
            <textarea
              name="notes"
              value={formData.notes || ''}
              onChange={handleFieldChange}
              className={inputClass}
              rows={3}
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={resetForm}
              className="rounded bg-red-700 px-4 py-2 text-white hover:bg-red-500"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-900"
            >
              {editingPatient ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PatientFormModal;
